import { intersect, partial, struct } from 'io-ts/lib/Decoder';

import { Id as JobId } from '../../../../job/Id';
import { Id as TransactionId } from '../../../../transaction/Id';

export const Params = intersect(
	struct({
		transactionId: TransactionId,
	})
)(
	partial({
		jobId: JobId,
	})
);
